/* eslint-disable max-len */
import React from 'react';

const Message: React.FC<object> = () => {

    return <svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.9992 22.1998L12.9971 22.1998C10.8055 22.209 8.64391 21.6902 6.69523 20.6872L6.52777 20.601L6.34506 20.6468L1.05582 21.9701L2.79961 17.8999L2.91438 17.632L2.73786 17.4001C1.44665 15.704 0.699219 13.6761 0.699219 11.4998C0.699219 5.65098 6.14175 0.799805 12.9992 0.799805C19.8567 0.799805 25.2992 5.65098 25.2992 11.4998C25.2992 17.3486 19.8567 22.1998 12.9992 22.1998ZM8.69922 9.8998V9.3998H8.19922H4.99922H4.49922V9.8998V13.0998V13.5998H4.99922H8.19922H8.69922V13.0998V9.8998ZM21.4992 9.8998V9.3998H20.9992H17.7992H17.2992V9.8998V13.0998V13.5998H17.7992H20.9992H21.4992V13.0998V9.8998ZM11.3992 9.3998H10.8992V9.8998V13.0998V13.5998H11.3992H14.5992H15.0992V13.0998V9.8998V9.3998H14.5992H11.3992Z" fill="white" stroke="white"/>
    </svg>;

};

export default Message;